var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_479_data_maintenance_flatline",
    "data-name": "#479_data_maintenance_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.34,258.21a.47.47,0,0,1-.35-.15.5.5,0,0,1,0-.71c3.13-3.13,3.7-46.74,4.21-85.22.4-30.68.78-59.66,2.4-66.68,3.72-16.13,20.93-17.33,21.1-17.33a.48.48,0,0,1,.53.46.49.49,0,0,1-.47.53c-.16,0-16.63,1.17-20.18,16.56-1.6,6.92-2,35.85-2.38,66.47-.63,48.3-1.33,82.74-4.51,85.92A.47.47,0,0,1,98.34,258.21Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,255a.5.5,0,0,1-.16-1c8-2.66,6.42-86.4,5.48-136.44-.49-25.74-.88-46.08-.08-50.59,1-5.65,2.65-8.87,4.93-9.55s3.94,1.22,4,1.3a.5.5,0,0,1-.72.68s-1.45-1.49-3-1c-1.3.39-3.08,2.23-4.23,8.76-.77,4.42-.39,24.71.1,50.4,1.34,70.89,1.88,134.74-6.16,137.41A.44.44,0,0,1,108,255Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.41,255a.52.52,0,0,1-.27-.07.5.5,0,0,1-.15-.69C108.11,243,117.33,86.51,116.86,72.4c-.14-4.28.8-7.08,2.79-8.32,2.68-1.67,6.17.17,6.32.25a.51.51,0,0,1,.2.68.49.49,0,0,1-.67.2s-3.14-1.64-5.33-.28c-1.66,1-2.44,3.54-2.31,7.44.2,6-1.89,48-5.07,91.38-2.79,38-7,84.69-11,91A.51.51,0,0,1,101.41,255Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.09,255H105a.5.5,0,0,1-.35-.61c2.07-7.89,2.84-18.68,2.84-39.8,0-5.31,0-130.13,2.37-139.16,2.24-8.63,15.44-6.27,16-6.16a.48.48,0,0,1,.39.58.49.49,0,0,1-.58.4c-.13,0-12.85-2.3-14.85,5.43-2.31,8.91-2.34,137.61-2.34,138.91,0,21.22-.78,32.07-2.88,40.05A.49.49,0,0,1,105.09,255Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.64,255.74a27,27,0,0,1-6.39-.8.5.5,0,0,1,.26-1c.12,0,11.66,3.08,15.82-3.42,2.45-3.81,2.45-26,2.44-45.57,0-15.07,0-29.3,1.06-34.66.75-3.84,2.47-6.56,5.09-8.1,4.42-2.57,9.75-.87,10-.79a.5.5,0,0,1,.32.63.51.51,0,0,1-.63.32s-5.14-1.64-9.16.71c-2.36,1.39-3.92,3.88-4.61,7.42-1,5.27-1,19.45-1,34.47,0,20.67,0,42.05-2.6,46.11C100.78,254.83,96.36,255.74,92.64,255.74Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.55,
    y: 49.21,
    width: 70.35,
    height: 206.77,
    transform: "translate(317.46 305.19) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.9,256.48H123.55a.49.49,0,0,1-.49-.5V49.21a.5.5,0,0,1,.49-.5H193.9a.5.5,0,0,1,.5.5V256A.5.5,0,0,1,193.9,256.48Zm-69.85-1h69.36V49.71H124.05Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 57.52,
    width: 6.14,
    height: 22.38,
    transform: "translate(387.81 137.42) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,80.39h-6.13a.49.49,0,0,1-.5-.49V57.52a.5.5,0,0,1,.5-.5H197a.5.5,0,0,1,.5.5V79.9A.49.49,0,0,1,197,80.39Zm-5.64-1h5.14V58h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 83.69,
    width: 6.14,
    height: 22.38,
    transform: "translate(387.81 189.76) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,106.56h-6.13a.49.49,0,0,1-.5-.49V83.69a.5.5,0,0,1,.5-.5H197a.5.5,0,0,1,.5.5v22.38A.49.49,0,0,1,197,106.56Zm-5.64-1h5.14V84.19h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 109.86,
    width: 6.14,
    height: 22.38,
    transform: "translate(387.81 242.1) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,132.74h-6.13a.5.5,0,0,1-.5-.5V109.86a.5.5,0,0,1,.5-.5H197a.5.5,0,0,1,.5.5v22.38A.5.5,0,0,1,197,132.74Zm-5.64-1h5.14V110.36h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 136.03,
    width: 6.14,
    height: 22.38,
    transform: "translate(387.81 294.44) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,158.91h-6.13a.5.5,0,0,1-.5-.5V136a.49.49,0,0,1,.5-.49H197a.49.49,0,0,1,.5.49v22.38A.5.5,0,0,1,197,158.91Zm-5.64-1h5.14V136.53h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 165.5,
    width: 6.14,
    height: 9.82,
    transform: "translate(387.81 340.83) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,175.82h-6.13a.5.5,0,0,1-.5-.5V165.5a.5.5,0,0,1,.5-.5H197a.5.5,0,0,1,.5.5v9.82A.5.5,0,0,1,197,175.82Zm-5.64-1h5.14V166h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 179.29,
    width: 6.14,
    height: 9.82,
    transform: "translate(387.81 368.4) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,189.61h-6.13a.5.5,0,0,1-.5-.5v-9.82a.5.5,0,0,1,.5-.5H197a.5.5,0,0,1,.5.5v9.82A.5.5,0,0,1,197,189.61Zm-5.64-1h5.14v-8.82h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 193.08,
    width: 6.14,
    height: 9.82,
    transform: "translate(387.81 395.98) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,203.4h-6.13a.5.5,0,0,1-.5-.5v-9.82a.5.5,0,0,1,.5-.5H197a.5.5,0,0,1,.5.5v9.82A.5.5,0,0,1,197,203.4Zm-5.64-1h5.14v-8.82h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 206.87,
    width: 6.14,
    height: 9.82,
    transform: "translate(387.81 423.56) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,217.19h-6.13a.5.5,0,0,1-.5-.5v-9.82a.5.5,0,0,1,.5-.5H197a.5.5,0,0,1,.5.5v9.82A.5.5,0,0,1,197,217.19Zm-5.64-1h5.14v-8.82h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 220.66,
    width: 6.14,
    height: 9.82,
    transform: "translate(387.81 451.14) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,231h-6.13a.5.5,0,0,1-.5-.5v-9.82a.5.5,0,0,1,.5-.5H197a.5.5,0,0,1,.5.5v9.82A.5.5,0,0,1,197,231Zm-5.64-1h5.14v-8.82h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 234.45,
    width: 6.14,
    height: 9.82,
    transform: "translate(387.81 478.72) rotate(-180)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,244.77h-6.13a.5.5,0,0,1-.5-.5v-9.82a.5.5,0,0,1,.5-.5H197a.5.5,0,0,1,.5.5v9.82A.5.5,0,0,1,197,244.77Zm-5.64-1h5.14V235h-5.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.59,
    y: 52.39,
    width: 10.08,
    height: 199.93,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67,252.81H119.59a.5.5,0,0,1-.5-.5V52.39a.5.5,0,0,1,.5-.5h10.08a.5.5,0,0,1,.5.5V252.31A.5.5,0,0,1,129.67,252.81Zm-9.58-1h9.08V52.88h-9.08Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.78,103.34s14.05-27.5,25-34.23l5.78,35.15Z",
    fill: "#9db0ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.33,142l7.39,100.53s-2.15,2.69-9.32,2.69-9.55-3.61-9.55-3.61l-15.53-73s-8.57,60.95-9.47,71.75c0,0-10.89,3.44-16.89-1.35,0,0,2.23-56.83,2.39-75.1a360.8,360.8,0,0,1,2.43-36.3h46.15Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.43,242.11a38.65,38.65,0,0,0,2.1,10.49c1.8,4.5,1.65,6.9,0,8.4s-10.2,1.65-14.25-1.05,1-9.82,1.05-12.6a57.23,57.23,0,0,0-.6-7Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,240.31s1.95,7.19,1.35,12-1.35,4.2-1.35,4.2l-9.89,0-.6-1.82a43.25,43.25,0,0,1-9.45,2.7c-4.49.6-14.39,0-14.09-1.95s11.24-5.4,14.09-8.85,9.6-12.29,9.6-12.29Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.76,69.11s30.14-5.34,40.57,1.41c9.23,18.35,9.23,76.25,9.23,76.25l-56.65,1.13S247.43,73.91,252.76,69.11Z",
    fill: "#9db0ef"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.85 74.15 272.11 97.08 264.46 77.93 279.85 74.15",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.1,97.57a.5.5,0,0,1-.46-.31L264,78.11a.5.5,0,0,1,.34-.67l15.39-3.77a.5.5,0,0,1,.49.15.49.49,0,0,1,.1.49l-7.74,22.92a.49.49,0,0,1-.46.34Zm-7-19.3,6.93,17.37,7-20.79Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.1,106.46a9.5,9.5,0,0,0-2.46-1.07c-.61,0-3.32,1.17-5.31-.77,0,0,.92,1-.92.92s-3.33.26-4.3-1.28a1.93,1.93,0,0,1-2.09-.92s-2,.21-2.2-1.48,1.58-4.81,1.58-4.81-4.85,1.43-6.95,2-2.3-1.25-1.53-2.2,7.36-3.07,10-3.38,12.52,2.87,14.72,4C284.61,97.46,285,103.55,284.1,106.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.1,107a.59.59,0,0,1-.26-.07,8.51,8.51,0,0,0-2.2-1,3.84,3.84,0,0,0-.45.09,5.88,5.88,0,0,1-4.34-.33,1.91,1.91,0,0,1-1.46.4h-.86c-1.37,0-2.71,0-3.66-1.24a2.45,2.45,0,0,1-2.15-.94,2.27,2.27,0,0,1-2.41-2,8.54,8.54,0,0,1,1.08-4c-1.58.45-4.37,1.25-5.82,1.61s-2.07-.25-2.32-.63a2.16,2.16,0,0,1,.26-2.4c1-1.21,7.93-3.28,10.32-3.56,2.85-.33,12.84,2.93,15,4.1a.49.49,0,0,1,.27.42c0,.25.41,6.21-.53,9.19a.54.54,0,0,1-.31.32A.58.58,0,0,1,284.1,107Zm-2.46-2.11a6.16,6.16,0,0,1,2.13.82,36.09,36.09,0,0,0,.34-7.9c-2.66-1.29-11.87-4.14-14.16-3.85-2.83.33-9.07,2.48-9.63,3.18a1.15,1.15,0,0,0-.2,1.19c.23.36.86.27,1.21.18,2.06-.5,6.88-1.92,6.93-1.93a.52.52,0,0,1,.55.17.51.51,0,0,1,0,.58c-.47.83-1.67,3.24-1.52,4.49s1.48,1,1.64,1a.54.54,0,0,1,.52.3c.38.83,1.48.63,1.52.62a.54.54,0,0,1,.54.24c.63,1,1.47,1.05,3,1h.89a2.5,2.5,0,0,0,.55,0l0,0a.52.52,0,0,1,.74-.72c1.41,1.37,3.27,1,4.27.73A4,4,0,0,1,281.64,104.87Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.87,106a.52.52,0,0,1-.08-1,.51.51,0,0,0,.48-.49,2.49,2.49,0,0,0-1.23,0,.52.52,0,0,1-.45-.88l1.84-1.74a.53.53,0,0,1,.73,0,.51.51,0,0,1,0,.73l-.86.82a1.61,1.61,0,0,1,.67.29,1,1,0,0,1,.35.77,1.56,1.56,0,0,1-1.36,1.52Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.11,104.78H271a.51.51,0,0,1-.41-.6,9.09,9.09,0,0,1,1.42-3.39.51.51,0,0,1,.72-.1.5.5,0,0,1,.1.72,8.32,8.32,0,0,0-1.23,3A.51.51,0,0,1,271.11,104.78Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,103.86a.52.52,0,0,1-.5-.42,4.77,4.77,0,0,1,1.69-4.26.52.52,0,0,1,.7.76,3.77,3.77,0,0,0-1.38,3.3.51.51,0,0,1-.4.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.24,122.36s-22.28-1.89-22.89-8.64,10.22-15,12.06-15.28,14.21,7.36,14.21,7.36Z",
    fill: "#9db0ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.61,110.75s-3.43,10.54,1.63,11.61,7.37-9.73,5.52-11.31S243.61,110.75,243.61,110.75Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.84,
    y: 106.46,
    width: 11.15,
    height: 3.17,
    transform: "translate(546.83 216.09) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,110.15H267.84a.51.51,0,0,1-.51-.52v-3.17a.51.51,0,0,1,.51-.52H279a.51.51,0,0,1,.51.52v3.17A.51.51,0,0,1,279,110.15Zm-10.63-1h10.11V107H268.36Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.91,
    y: 106.46,
    width: 41.93,
    height: 3.17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.84,110.15H225.91a.51.51,0,0,1-.51-.52v-3.17a.51.51,0,0,1,.51-.52h41.93a.52.52,0,0,1,.52.52v3.17A.52.52,0,0,1,267.84,110.15Zm-41.41-1h40.9V107h-40.9Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.84 106.46 251.61 82.41 208.66 82.41 225.91 106.46 267.84 106.46",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.84,107H225.91a.52.52,0,0,1-.42-.22L208.24,82.71a.55.55,0,0,1,0-.54.53.53,0,0,1,.46-.28h43a.51.51,0,0,1,.43.23l16.23,24a.51.51,0,0,1,0,.53A.53.53,0,0,1,267.84,107Zm-41.66-1h40.69l-15.54-23H209.67Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,115.66s-.1-3.78.82-4.91,9-6.64,9.81-5.52-2,4.09-2,4.09,19.12-1.22,18.81.11-1.43,1.84-2.86,2.24-8,1.64-9.61,2.46-7.47,3.17-10.33,2.86A12.5,12.5,0,0,1,242.79,115.66Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,117.54a4,4,0,0,1-.61,0,12.9,12.9,0,0,1-4.81-1.39.53.53,0,0,1-.26-.43c0-.41-.07-4,.94-5.25.82-1,7.68-5.86,9.82-5.86h0a.91.91,0,0,1,.77.36c.73,1-.34,2.68-1.25,3.8,6.83-.41,17-.84,18,.23a.69.69,0,0,1,.15.58c-.39,1.69-1.87,2.24-3.23,2.63-.46.13-1.39.34-2.57.6a49.69,49.69,0,0,0-6.95,1.82C256.92,115.11,251.32,117.54,248,117.54Zm-4.65-2.19a13,13,0,0,0,4.15,1.13c2.59.27,8.15-1.87,10-2.81a45.81,45.81,0,0,1,7.19-1.91c1.11-.25,2.07-.46,2.51-.58,1.27-.36,2.09-.76,2.42-1.59-1.62-.48-10.28-.26-18.2.25a.52.52,0,0,1-.4-.88c1.16-1.2,2.23-2.85,2-3.37H253c-1.36,0-8,4.33-9,5.49C243.46,111.74,243.29,113.93,243.3,115.35Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.33,70.52s31.68,30.21,28,49.44S283.49,109,283.49,109L284,96.35l13.79,4.74Z",
    fill: "#9db0ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.69,106a.51.51,0,0,1-.17,0l-26.67-9.18a.51.51,0,0,1-.32-.65.52.52,0,0,1,.66-.32L310.86,105a.51.51,0,0,1,.32.65A.52.52,0,0,1,310.69,106Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.81,101.61a.51.51,0,0,1-.51-.44L294.44,81.7a.52.52,0,0,1,1-.15L298.32,101a.52.52,0,0,1-.44.58Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.06,55.53c.48-5.32,0-9.86-2.85-14.58a5.3,5.3,0,0,0-1.89-2.06c-.73-.39-1.24-.17-2-.12a3.33,3.33,0,0,1-1.9-.42,8.73,8.73,0,0,0-4.78-.16c-2.05.42-4,1.25-6.08,1.6a7.05,7.05,0,0,1-5.93-1.28A4.81,4.81,0,0,0,256,42.83a6,6,0,0,1-3.56-1.21,5.77,5.77,0,0,0,1.07,5,3.19,3.19,0,0,1,.44.6,2.43,2.43,0,0,1,.2,1,20.68,20.68,0,0,0,.53,4,6,6,0,0,0,2.12,3.34",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.06,56.05H279a.51.51,0,0,1-.46-.56c.54-6-.27-10.12-2.78-14.28a4.84,4.84,0,0,0-1.69-1.86,1.73,1.73,0,0,0-1.19-.12l-.51.06a3.22,3.22,0,0,1-1.73-.3l-.4-.15a8.14,8.14,0,0,0-4.49-.15c-.91.19-1.83.47-2.72.74a26.41,26.41,0,0,1-3.37.87,8.34,8.34,0,0,1-5.41-.72,4.27,4.27,0,0,0,2,2.8.52.52,0,0,1,.24.58.51.51,0,0,1-.5.39h0a6.47,6.47,0,0,1-3.19-.87,5.25,5.25,0,0,0,1.1,3.78l.09.11a2.75,2.75,0,0,1,.41.6,3,3,0,0,1,.26,1.14l0,.42a17.68,17.68,0,0,0,.48,3.48,5.62,5.62,0,0,0,1.93,3.07.52.52,0,1,1-.61.83,6.65,6.65,0,0,1-2.32-3.63,19.29,19.29,0,0,1-.51-3.68l0-.41a2.28,2.28,0,0,0-.15-.77,2.35,2.35,0,0,0-.29-.4l-.09-.11A6.29,6.29,0,0,1,252,41.49a.54.54,0,0,1,.33-.36.49.49,0,0,1,.48.08,5.48,5.48,0,0,0,1.53.81,5.31,5.31,0,0,1-1.19-3.54.52.52,0,0,1,.87-.36,6.45,6.45,0,0,0,5.5,1.16,24.48,24.48,0,0,0,3.24-.84c.91-.27,1.85-.56,2.81-.76a9.17,9.17,0,0,1,5.07.19L271,38a2.15,2.15,0,0,0,1.27.23l.45,0a2.66,2.66,0,0,1,1.81.22,5.65,5.65,0,0,1,2.09,2.25c2.61,4.3,3.48,8.76,2.93,14.9A.52.52,0,0,1,279.06,56.05Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.67,68.88l.79,9.05s2,5.64,7.66,3.52a12.05,12.05,0,0,0,7.14-7.51l-2.05-16.5s-4.62-1.79-4.48-11.36a29.18,29.18,0,0,1-15,3.94s-1.42,10.54-.17,15S263.67,68.88,263.67,68.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.69,82.44a5.4,5.4,0,0,1-2.33-.51A7.22,7.22,0,0,1,264,78.1a.51.51,0,0,1,0-.13l-.75-8.56h0a5.94,5.94,0,0,1-6.07-4.26c-1.27-4.5.09-14.76.15-15.19a.56.56,0,0,1,.52-.45H258a29,29,0,0,0,14.48-3.86.52.52,0,0,1,.8.44c-.14,9,4.1,10.85,4.15,10.87a.52.52,0,0,1,.32.42l2.06,16.5a.71.71,0,0,1,0,.2,12.47,12.47,0,0,1-7.46,7.85A7.45,7.45,0,0,1,269.69,82.44ZM265,77.81A6.2,6.2,0,0,0,267.8,81a5.26,5.26,0,0,0,4.14,0,11.61,11.61,0,0,0,6.8-7.06l-2-16.12c-1-.56-4.38-3-4.52-10.8a30.06,30.06,0,0,1-14,3.56c-.25,2-1.2,10.54-.13,14.33,1.11,4,5.33,3.51,5.5,3.5a.52.52,0,0,1,.58.46Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.09,73.61s2.4.18,4.67-2.61,1.88-4.21,1.88-4.21a11,11,0,0,1-7,2.09Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,74.11h-.13a.5.5,0,0,1-.46-.45l-.41-4.74a.51.51,0,0,1,.14-.39.47.47,0,0,1,.39-.15,10.4,10.4,0,0,0,6.62-2,.5.5,0,0,1,.47-.09.5.5,0,0,1,.32.34c.05.17.4,1.75-2,4.66A6.64,6.64,0,0,1,264.18,74.11Zm0-4.71.32,3.69a6,6,0,0,0,3.84-2.41,8.44,8.44,0,0,0,1.68-2.91,11.42,11.42,0,0,1-5.68,1.63Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.3,54.77s-2.11,5.46-1.17,6.12,2.93-.36,2.93-.36",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,61.61a1.9,1.9,0,0,1-1.12-.31c-1-.73,0-4,1-6.71a.5.5,0,0,1,.93.36c-1,2.54-1.6,5.13-1.33,5.56.5.33,1.83-.14,2.39-.43a.51.51,0,0,1,.68.22.5.5,0,0,1-.22.67A5.81,5.81,0,0,1,264,61.61Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.59,64.91A7.84,7.84,0,0,1,260,63.1a.51.51,0,0,1-.05-.71.49.49,0,0,1,.7,0,6.57,6.57,0,0,0,4.69,1.52,5.81,5.81,0,0,0,3.9-3.15.5.5,0,1,1,.86.5c-1.24,2.12-2.79,3.34-4.6,3.63A5.07,5.07,0,0,1,264.59,64.91Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266,
    cy: 53.63,
    rx: 0.58,
    ry: 1.33,
    transform: "translate(-5.35 52.62) rotate(-11.19)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.28,
    cy: 54.96,
    rx: 0.58,
    ry: 1.33,
    transform: "translate(-5.74 51.34) rotate(-11.19)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.93,57a.51.51,0,0,1-.49-.41l-.94-5.13a.49.49,0,0,1,.08-.37.49.49,0,0,1,.32-.21l7-1.29a.5.5,0,0,1,.58.41l.95,5.12a.55.55,0,0,1-.08.38.54.54,0,0,1-.32.21L265,57Zm-.36-5.23.77,4.15,6-1.11-.76-4.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.24,58.57a.49.49,0,0,1-.49-.41L254.81,53a.45.45,0,0,1,.08-.37.47.47,0,0,1,.32-.21l7-1.28a.49.49,0,0,1,.58.4l.94,5.13a.45.45,0,0,1-.08.37.51.51,0,0,1-.32.21l-7,1.28Zm-.36-5.23.76,4.15,6-1.11-.76-4.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.39,53.47h0l-4.77-.37a.5.5,0,0,1-.46-.54.5.5,0,0,1,.54-.46l4.76.38a.49.49,0,0,1,.46.53A.5.5,0,0,1,276.39,53.47Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.14,55.51A8,8,0,0,1,274.85,53a2.75,2.75,0,0,1,1.42-.85,2.45,2.45,0,0,1,1.33.21,4.82,4.82,0,0,1,2.67,2.87,3.72,3.72,0,0,1,.17,1.84,4.26,4.26,0,0,1-1.54,2.43,12.07,12.07,0,0,1-2.52,1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.38,61.48a.52.52,0,0,1-.46-.29.51.51,0,0,1,.23-.69,12.18,12.18,0,0,0,2.42-1.44,3.67,3.67,0,0,0,1.36-2.12,3.4,3.4,0,0,0-.15-1.59,4.25,4.25,0,0,0-2.38-2.55,1.84,1.84,0,0,0-1-.18,2.29,2.29,0,0,0-1.13.71,7.59,7.59,0,0,0-1.61,2.38.52.52,0,1,1-.95-.4,8.76,8.76,0,0,1,1.83-2.71,3.24,3.24,0,0,1,1.69-1,2.94,2.94,0,0,1,1.62.25,5.32,5.32,0,0,1,3,3.17,4.38,4.38,0,0,1,.19,2.1,4.8,4.8,0,0,1-1.72,2.74,13,13,0,0,1-2.62,1.56A.46.46,0,0,1,276.38,61.48Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.18,149.83c-8.12,0-11.17-9.7-13.86-18.25-1.91-6.08-3.72-11.82-6.94-11.82h0a.5.5,0,1,1,0-1h0c3.94,0,5.77,5.8,7.88,12.52,2.59,8.22,5.52,17.55,12.91,17.55,4.72,0,6.56-12.45,8.18-23.43.66-4.46,1.28-8.68,2.07-12,.71-3,1.74-4.91,3-5.6a1.91,1.91,0,0,1,1.52-.19.49.49,0,0,1,.29.64.5.5,0,0,1-.63.29,1.1,1.1,0,0,0-.76.17c-.57.32-1.65,1.4-2.48,4.92-.78,3.31-1.4,7.51-2.06,12C222.58,137.48,220.76,149.83,215.18,149.83Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8,127.11c-11,0-25.11-13.84-25.76-14.48a.52.52,0,1,1,.73-.73c.17.16,16.88,16.52,27.5,13.89a.52.52,0,0,1,.63.38.51.51,0,0,1-.38.62A11.19,11.19,0,0,1,312.8,127.11Z",
    fill: "#231f20"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebMaintenance);
export default __webpack_public_path__ + "static/media/web_maintenance.963032291dd6e1bfb2151011c95d09ba.svg";
export { ForwardRef as ReactComponent };